export default "__VITE_ASSET__a96f42ab__"